import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageKeys } from '../../../enums/local-storage-keys.enum';
import { AppRoutesEnum } from '../../../enums/app-routes.enum';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private _router: Router,
  ) {}

  public canActivate(): Observable<boolean> | boolean {
    const token = localStorage.getItem(LocalStorageKeys.Token);

    if (!token) {
      this._router.navigate([AppRoutesEnum.Login]);

      return false;
    }

    return true;
  }
}
